module.exports = function(app) {
    // used to format and display a standardized JSON formatted address
    app.directive('portalAddress', [function () {
        return {
            restrict: "A",
			template: "<div class='portalAddress'>" +
					      "<div class='address1'>{{address.address1}}</div>" +
		                  "<div class='address2' data-ng-if='address.address2'>{{address.address2}}</div>" +
		                  "<div class='address3' data-ng-if='address.address3'>{{address.address3}}</div>" +
		                  "<div>{{address.city}}, {{address.state}} " +
                          "{{address.zipCode.base}}<span data-ng-show='address.zipCode.secondary'>-{{address.zipCode.secondary}}</span></div>" +
	                  "</div>",
            scope: {
                address: "=portalAddress"
            }
        };
    }]);
};